Object.defineProperty(exports, "__esModule", {
  value: true
});
var visuallyHidden = {
  position: 'absolute',
  display: 'block',
  border: 0,
  margin: '-1px',
  padding: 0,
  height: '1px',
  width: '1px',
  clip: 'rect(0, 0, 0, 0)',
  overflow: 'hidden'
};

exports['default'] = visuallyHidden;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/visuallyHidden.js
// module id = 159
// module chunks = 168707334958949